import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {moduloPerform} from '../../diccionarios/performValuesModulo';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { CommonFormService } from 'src/app/shared/utils/common-form.service';
import { SeguimientoUserService } from '../../services/orden-proceso-services/seguimiento-user.service';
import { MantenedorParametrosRaspberryService } from '../../services/orden-proceso-services/mantenedor-parametros-raspberry.service';
import { MantenedorIoIndustriasPlcService } from '../../services/orden-proceso-services/mantenedor-io-industrias.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { PlantaService } from '../../services/general-services/planta.service';
import { LineaService } from '../../services/general-services/linea.service';

@Component({
  selector: 'app-mantenedor-ordenproceso-perform',
  templateUrl: './mantenedor-ordenproceso-perform.component.html',
  styleUrls: ['./mantenedor-ordenproceso-perform.component.css']
})
export class MantenedorOrdenProcesoPerformComponent implements OnInit {

  titulo: string = "Solicitar ordenes de proceso";

  formulario: FormGroup;
  formularioCustom: FormGroup;

  columnDefs: any[];
  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;

  selectedRow: any;

  cmbPlanta: any[] = [];
  cmbLinea: any[] = [];

  memoryList: any[] = [];

  columnDefsModal: any[];
  rowDataModal: any[] = [];
  frameworkComponentsModal: any;
  gridApiModal: any;
  gridColumnApiModal: any;
  rowSelectionModal: any;

  textBoton: string;
  textoBuscar: string;
  textoBuscarRasp: string;
  mostrarFormulario = false;
  mostrarFormularioRasp = false;
  deshabilitarLineaRasp:boolean = true;

  tvcModulo: any;
  editableForm = false;

  loading: boolean = false;
  listaVacia: boolean = true;
  listaVaciaRasp: boolean = true;
  loadingRasbian: boolean = false;

  estadoContenedor: boolean = false;
  estadoBd: boolean = false;
  textoContenedor: string = "Solicitando";
  textoBd: string = "Solicitando";
  textoCantidadRasp = "Solicitando";
  textoCantidadNonRasp = "Solicitando";

  DAT_BTNS: any;
  DAT_MSG: any;
  DAT_BTNCSS: any;


  cmbOpcion: any[] = [
    { clave: 1, valor: 'Activo' },
    { clave: 0, valor: 'Inactivo' }
  ];

  cmbOpcionModal: any[] = [
    { clave: true, valor: 'Activo' },
    { clave: false, valor: 'Inactivo' }
  ];

  check: HTMLInputElement;

  bandchek: boolean = true;
  banderaString: boolean;
  bandNumLinea: boolean = true;

  lineaSeledted: any;

  cmbTipoDato: any[] = [
    { clave: 'BYTE', valor: 'BYTE' },
    { clave: 'INT', valor: 'INT' },
    { clave: 'DINT', valor: 'DINT' },
    { clave: 'REAL', valor: 'REAL' },
    { clave: 'STRING', valor: 'STRING' },
  ];

  //!esta catalogo lo debe pasar el tio domo
  cmbPropiedad: any[] = [
    { clave: 'turno', valor: 'TURNO' },
    { clave: 'idSec', valor: 'ID SECUENCIA' },
    { clave: 'lote', valor: 'LOTE' },
    { clave: 'ordProduccion', valor: 'ORDEN PRODUCCION' },
    { clave: 'codArticulo', valor: 'CODIGO ARTICULO' },
    { clave: 'peso', valor: 'PESO' }
  ];

  @ViewChild('fileInput') fileInput: ElementRef;
  formInputFile: FormGroup;

  DATA = [];
  constructor(
    private fb: FormBuilder,
    private _util: UtilsService,
    private _commonForm: CommonFormService,
    private _raspberry: MantenedorParametrosRaspberryService,
    private _planta: PlantaService,
    private _linea: LineaService,
    private _indsutriasIo: MantenedorIoIndustriasPlcService,
    private _logServices : SeguimientoUserService,
  ) { }

  URI: string = 'ORDENES DE PROCESO';

  ngOnInit() {
    this._logServices.saveSeguimientoPerform(this.URI); //Ticket 30238 LOG de ingreso en modulos perform

    this.tvcModulo = moduloPerform;
    this.DAT_BTNS = this.tvcModulo.button.buttonsNombre;
    this.DAT_MSG = this.tvcModulo.mensajes;
    this.DAT_BTNCSS = this.tvcModulo.button.buttonsCss;

    this.formularioCustom = this.fb.group({
      planta: ['', [Validators.required]],
      linea: ['', [Validators.required]]
    });


    this.formInputFile = this.fb.group({
      multipart: ['', [Validators.required]]
    });
    this.cargarGrig();
    //*INVOCACION DE SERVICIOS AL INICIO 
    //this.getAll();
    this.getAllPlanta();
    this.getAllOrdenProceso();
    setTimeout(() => {
      //this.check = document.getElementById("idPropiedad") as HTMLInputElement;
      //this.check.checked = false;
    }, 200);
  }

  /** SERVICIOS */
  getAll() {
    this.loading = true;
    this._raspberry.getAllParam().subscribe((res: any[]) => {
      this.loading = false;
      this.rowData = res;
      
      this.listaVacia = this.rowData.length > 0 ? false : true;
    }, (err) => {
      // this.listaVacia = true;
      // this.loading = false;
      // console.log(err);
      // this._util.validateError(err);
      this.loading = false;
      this.rowData = this.DATA;
      this.listaVacia = this.rowData.length === 0 ? true : false;
    });
  }

  getAllOrdenProceso(){
    this._indsutriasIo.getAllOrdenProceosNonProcesed().subscribe((res: any) => {
      this.rowData = res;
      this.listaVacia = this.rowData.length > 0 ? false : true;
      console.log(res);
    }, (err) => {
      this.loading = false;
      this.rowData = this.DATA;
      this.listaVacia = this.rowData.length === 0 ? true : false;
    });
  }

  getAllPlanta() {
    this._planta.getAllbyPerfor().subscribe((res: any) => {
      this.cmbPlanta = res.respuesta;
    }, (err) => {
      this.cmbPlanta = [];
    });
  }

  /** FUNCIONES */
  nuevo() {
    this.textBoton = this.DAT_BTNS.guardar;
    this.titulo = "Guardar Parametrización Raspberry";
    this._commonForm.abrirFormularioParaGuardar(this);
  }

  editar({ rowData }) {
    let id = 0;
    this.cmbPlanta.forEach(element =>{
      if(element.nombre === rowData.nombrePlanta){
        id = element.id;
      }
    });
    this.cmbLinea = [{id:rowData.idLinea,nombre:rowData.nombreLinea}];
    const clonData = {
      active: rowData.active,
      ipRb: rowData.ipRb,
      nombre: rowData.nombre,
      idLinea: rowData.idLinea,
      port: rowData.port,
      idPlanta: id
    }
    this.textBoton = this.DAT_BTNS.editar;
    this.titulo = "Editar Parametrización Raspberry";
    this._commonForm.abrirFormularioParaEditar(this, clonData);
  }


  carfas(from,row){
     const obj = from.cmbLinea.find( e => e.id === row.data.idLinea);
     if(obj !== undefined)
      return obj.nombre;
     else
      return '?'; 
   }
  

  cargarGrig() {
    this.columnDefs = [
      {
        headerName: "",
        cellRenderer: "buttonRenderer",
        width: 100,
        cellRendererParams: {
          onClick: this.procesarSolicitud.bind(this),
          label: "Agregar",//this.tvcModulo.button.buttonsNombre.agregar,
          colorBoton: this.tvcModulo.button.buttonsCss.info,
        },
      },
      {
        headerName: "Orden Proceso",
        field: "ordenProceso",
        sortable: true,
        filter: true,
        width: 150,
      },
      {
        headerName: "Material",
        field: "material",
        sortable: true,
        filter: true,
        width: 200,
      },
      {
        headerName: "Lote",
        field: "lote",
        sortable: true,
        filter: true,
        width: 150,
      },
      {
        headerName: "Cantidad",
        field: "cantidad",
        sortable: true,
        filter: true,
        width: 150,
      },
      {
        headerName: "Descripción",
        field: "desca",
        sortable: true,
        filter: true,
        width: 350,
      },
      
    ];
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.rowSelection = "multiple";
  }


  changeRowColor(params) {
    if (params.data.active) {
      return { 'color': 'green', 'font-weight': 'bold' };
    } else {
      return { 'color': 'red', 'font-weight': 'bold' };
    }
  }

  changeRowColorStatus(params) {
    if (params.data.status) {
      return { 'color': 'green', 'font-weight': 'bold' };
    } else {
      return { 'color': 'red', 'font-weight': 'bold' };
    }
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onGridReadyModal(params) {
    this.gridApiModal = params.api;
    this.gridColumnApiModal = params.columnApi;
  }

  acciones(event) {
    console.log(event);
    if (event === "guardar") {
      if (this.editableForm) {
      } else {
        this.guardar();
      }
    }else if(event == "enviar"){
      this.enviarConfigRaspberry();
    } else {
      this.titulo = "Parametrización Raspbery";
      this._commonForm.limpiarYregrear(this);
    }
  }

  enviarConfigRaspberry(){

    this._util.confirmarSincronoPromesa(
      {
        title: this.tvcModulo.mensajes.guardar,
        text: ``,
        action: this.tvcModulo.button.buttonsNombre.guardar,
        funcion: this._indsutriasIo.enviarConfigPlc(this.formulario.value),
      }
    ).then((res: any) => {
      this.titulo = "Parametrización Raspberry";
        this.getAll();
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }


  eliminar({ rowData }) {

    this._util.confirmarSincronoPromesa(
      {
        title: this.tvcModulo.mensajes.eliminar,
        text: ``,
        action: this.tvcModulo.button.buttonsNombre.eliminar,
        funcion: this._raspberry.deleteRaspberry(rowData.idLinea),
      }
    ).then((res: any) => {
      this.rowData = this.rowData.filter((item) => item.idLinea !== rowData.idLinea);
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  guardar() {

    this._util.confirmarSincronoPromesa(
      {
        title: this.tvcModulo.mensajes.guardar,
        text: ``,
        action: this.tvcModulo.button.buttonsNombre.guardar,
        funcion: this._raspberry.createRaspberry(this.formulario.value),
      }
    ).then((res: any) => {
      this.titulo = "Parametrización Raspberry";
      this.getAll();
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }



  callModalRasp({ rowData }) {
    this.deshabilitarLineaRasp = true;
    //this.plantilla.idLinea = rowData.idLinea;
    //this.lineaSeledted = this.plantilla.ipRb;
    document.getElementById('callModal').click();
    //this.getParamslinea();
  }


  callModal({ rowData }) {
    this.mostrarFormularioRasp = true;
  }

  getLineaPlantaByid(idPlanta) {
    const planta = this.cmbPlanta.find((e) => e.id === idPlanta);
    this._linea.lineasByCodigoPlantaActiva(planta.id).subscribe((res: any[]) => {
      this.cmbLinea = res;
      //this.cargarGridRasp();
    }, (err) => {
      this.cmbLinea = [];
      console.log(err);
    });
  }

  getLineaPlanta() {
    let idPlanta = this.formularioCustom.get('planta').value;
    const planta = this.cmbPlanta.find((e) => e.id === idPlanta);
    console.log(planta);
    this._linea.getByIdbyPerfor(planta.id).subscribe((res: any[]) => {
      this.cmbLinea = res;
    }, (err) => {
      this.cmbLinea = [];
      console.log(err);
    });
  }



  exportar() {
    const cabecera: any[] = [['DB', 'PROPIEDAD', 'POSICION', 'TDATO', 'LONGITUD', 'ENVIADO', 'STATUS']];
    const data: any[] = this.rowDataModal.map((x) => Object.assign({}, x));
    let body = [];
    data.forEach(e => {
      body.push({ "db": e.db, "propiedad": e.propiedad, "posicion": e.posicion, "tdato": e.tdato, "longitud": e.longitud, "enviado": e.enviado, "status": e.status });
    });
    this._util.exportCSV(cabecera, body, "config.csv");
  }

  clickChosseFile() {
    this.fileInput.nativeElement.value = '';
    this.formInputFile.get('multipart').setValue('');
    document.getElementById('csvInput').click();
  }

  async onFileSelect(event) {
    let allowedExtensions = /(.csv)$/i;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.formInputFile.get('multipart').setValue('');
        this._util.mensajeErrorVisto('El tipo de archivo no es valido, el tipo de archivo permitido es "CSV" ', true, 9000);
        this.fileInput.nativeElement.value = '';
      } else {
        this.formInputFile.get('multipart').setValue(file);
        this.importar(file);
      }
    }
  }

  async importar(file: any) {
    this.rowDataModal = [];
    const str = await this._util.readFileContent(file);
    const filas = str.split(/\r\n|\n/);
    const cabecera = filas[0].split(/\t|;/);
    let cuerpo: any[] = [];
    filas.forEach((col, i) => {
      if (i > 0) {
        let columna = filas[i].split(/\t|;/);
        if (columna.length == cabecera.length) {
          cuerpo.push({ "db": columna[0], "propiedad": columna[1], "posicion": columna[2], "tdato": columna[3], "longitud": columna[4], "enviado": columna[5], "status": columna[6] });
        }
      }
    });
    let hash = {};
    cuerpo = cuerpo.filter(o => hash[o.propiedad] ? false : hash[o.propiedad] = true);
    this.rowDataModal = cuerpo;
  }


  enviarSolicitud(){

    this._util.confirmarSincronoPromesa(
      {
        title: this.tvcModulo.mensajes.actualizar,
        text: ``,
        action: this.tvcModulo.button.buttonsNombre.actualizar,
        funcion: this._indsutriasIo.procesarOrdenProceso(this.selectedRow.material,this.selectedRow.ordenProceso,this.formularioCustom.get("linea").value),
      }
    ).then((res: any) => {
      this.getAllOrdenProceso();
        document.getElementById('cerrarModal').click();
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  procesarSolicitud( { rowData } ){
    this.selectedRow = rowData;
    console.log(rowData);
    rowData.lote;
    rowData.ordenProceso;
    document.getElementById('abrirModal').click();
    
  }
  
}
